<template>
	<div class="footBox">
		<div class="footCont">
			<div class="footContTop">
				<div class="footLeft1">
					<div class="footIcon"><img src="@/assets/img/logoWz.png" alt="" /></div>
					<div class="footKf">
						<p>{{ appPhone.configValue }}</p>
						<p>{{ appTime.configValue }}</p>
					</div>
				</div>
				<div class="footLeft2">
					<div class="footXy">
						<div class="footXyT">协议政策</div>
						<p @click="xyBtn(2)" class="supHove3">用户协议</p>
						<p @click="xyBtn(3)" class="supHove3">隐私政策</p>
						<p @click="fkBtn" class="supHove3">帮助反馈</p>
					</div>
					<div class="footXy">
						<div class="footXyT">关于我们</div>
						<p @click="dlBtn" class="supHove3">登录平台</p>
						<p @click="xyBtn(4)" class="supHove3">关于平台</p>
						<p @click="xyBtn(5)" class="supHove3">联系我们</p>
					</div>
				</div>
				<div class="footLeft3">
					<div class="erw supHove2">
						<img :src="$assetUrl(appWxOffic?.configValue)" alt="" />
						<p>微信公众号</p>
					</div>
					<div class="erw supHove2">
						<img :src="$assetUrl(appMiniPic?.configValue)" alt="" />
						<p>微信小程序</p>
					</div>
				</div>
			</div>
			<div class="footContBot">
				© 2014-20201 {{ appCompany?.configValue }}
				&nbsp;
				<i @click="baBtn">
					{{ icpData?.configValue }}
				</i>
				&nbsp;
				<i @click="gaBtn(gaData?.configValue)">{{ gaData?.configValue }}</i>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'vuex';
export default {
	name: 'fooT',
	data() {
		return {};
	},
	computed: {
		...mapState(['icpData', 'gaData', 'appCompany', 'appMiniPic', 'appWxOffic', 'appLogo', 'appPhone', 'appTime'])
	},
	methods: {
		baBtn() {
			window.open('https://beian.miit.gov.cn/#/Integrated/index', '_blank');
		},
		gaBtn(val) {
			let num = val.match(/\d+/g)[0];
			window.open(`http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=${num}`);
		},
		xyBtn(type) {
			this.$router.push({
				path: 'userAgreen',
				query: {
					type
				}
			});
		},
		fkBtn() {
			this.$router.push({
				path: 'feedback'
			});
		},
		dlBtn() {
			if (localStorage.getItem('token')) {
				this.$message('当前已经登录啦');
				return;
			}
			this.$router.push({
				path: 'login'
			});
		}
	},
	mounted() {}
};
</script>
<style lang="scss" scoped>
.footBox {
	background: #323438;
	height: 261px;
	display: flex;
	justify-content: center;
	.footCont {
		width: 1200px;
		.footContTop {
			display: flex;
			height: calc(100% - 54px);
			box-sizing: border-box;
			padding-top: 21px;
			.footLeft1 {
				width: 170px;
				.footIcon {
					height: 32px;
					margin-bottom: 37px;
					img {
						height: 100%;
					}
				}
				.footKf {
					font-size: 12px;
					color: #999a9c;
					p {
						margin-bottom: 20px;
						cursor: pointer;
					}
				}
			}
			.footLeft2 {
				display: flex;
				margin-top: 12px;
				flex: 1;
				padding-left: 166px;
				.footXy {
					&:nth-of-type(1) {
						margin-right: 71px;
					}
					.footXyT {
						font-size: 14px;
						color: #fff;
						margin-bottom: 24px;
					}
					p {
						font-size: 12px;
						color: #999a9c;
						margin-bottom: 20px;
						cursor: pointer;
					}
				}
			}
			.footLeft3 {
				display: flex;
				margin-top: 8px;

				.erw {
					width: 95px;
					margin-right: 52px;
					cursor: pointer;
					img {
						width: 100%;
						vertical-align: bottom;
					}
					p {
						margin-top: 14px;
						text-align: center;
						color: #ffffff;
						font-size: 12px;
					}
				}
			}
		}
		.footContBot {
			height: 53px;
			border-top: 1px solid rgba(255, 255, 255, 0.14);
			display: flex;
			justify-content: center;
			align-items: center;
			font-size: 12px;
			color: #999a9c;
			i {
				cursor: pointer;
			}
		}
	}
}
</style>
